// extracted by mini-css-extract-plugin
export default {"gallery":"SortableGallery_gallery__V3HRO","overlay":"SortableGallery_overlay__LGvAf"};